"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enableAuth = exports.useAuth = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _auth = require("../api/auth");

var _utils = require("../api/utils");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _user = require("../reducers/user");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AuthContext = /*#__PURE__*/_react["default"].createContext((0, _user.defaultUserState)());

var useAuth = function useAuth() {
  return _react["default"].useContext(AuthContext);
};

exports.useAuth = useAuth;

var enableAuth = function enableAuth(Component, config) {
  (0, _utils.Config)(config);

  var EnableAuth = function EnableAuth(_ref) {
    var authFunc = _ref.authFunc,
        props = _objectWithoutProperties(_ref, ["authFunc"]);

    _react["default"].useEffect(function () {
      authFunc();
    }, [authFunc]);

    return /*#__PURE__*/_react["default"].createElement(AuthContext.Provider, {
      value: props.user
    }, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      isAuthenticating: (0, _lodash["default"])(props, ["user", "isAuthenticating"], false)
    })));
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      user: state.user
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, {
    authFunc: _auth.auth
  })(EnableAuth);
};

exports.enableAuth = enableAuth;